import React from 'react';
import { Skeleton } from '@cubeyou-team/hx-react-components';

const RepositoryItemLoader = () => {
  const speed = 2;
  return (
    <>
      <Skeleton speed={speed} width={260} height={46} viewBox="0 0 260 46">
        <circle cx="16" cy="22" r="8" />
        <rect x="40" y="16" rx="4" ry="4" width="242" height="14" />
      </Skeleton>
    </>
  );
};
export default RepositoryItemLoader;
